import { render, staticRenderFns } from "./Paternity.vue?vue&type=template&id=78782424&scoped=true"
import script from "./Paternity.vue?vue&type=script&lang=js"
export * from "./Paternity.vue?vue&type=script&lang=js"
import style0 from "./Paternity.vue?vue&type=style&index=0&id=78782424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78782424",
  null
  
)

export default component.exports